import React from "react";
import { PlusCircle } from "react-bootstrap-icons";
import { DashCircle } from "react-bootstrap-icons";
import Choice from "./Choice";
import { Icon } from "../util/Icon";

function Question({ question, onUpdate, onDelete }) {
  const onChoiceUpdate = (c) => {
    const i = question.choices.findIndex((_c) => _c.no === c.no);

    question.choices.splice(i, 1, c);

    onUpdate(question);
  };

  return (
    <div>
      <div className="row my-2">
        <div className="col-10">
          <label className="form-label justify-content-start pe-3 fs-5">
            Question {question.no}{" "}
            {(question.type === "RADIO" || question.type === "CHECK") && (
              <>
                <span
                  onClick={() => {
                    question.choices.push({
                      no: question.choices.length + 1,
                      text: "",
                    });
                    onUpdate(question);
                  }}
                >
                  <PlusCircle size={25} className="ms-2" />
                </span>
                <span
                  onClick={() => {
                    question.choices.pop();
                    onUpdate(question);
                  }}
                >
                  <DashCircle size={25} className="ms-2" />
                </span>
              </>
            )}
          </label>
        </div>
        <div className="col-2">
          <button
            type="button"
            className="btn btn-outline-danger btn-rounded float-end"
            onClick={() => {
              onDelete(question);
            }}
          >
            <Icon iconName="Trash" className="fas me-2 mx-auto" />
          </button>
        </div>
      </div>

      <input
        type="text"
        className="form-control"
        defaultValue={question.text}
        onChange={(e) => {
          question.text = e.target.value;
          onUpdate(question);
        }}
      />
      <ul>
        {question.choices.map((c) => (
          <Choice
            key={c.no}
            choice={c}
            onUpdate={onChoiceUpdate}
            type={question.type}
          />
        ))}
      </ul>
    </div>
  );
}

export default Question;
